export enum LegalTransactionRelationshipTypeEnum {
  PurchaseContract = 1,
  Inheritance = 2,
  Mortgage = 3,
  Company = 4,
  Marriage = 5,
  Family = 6,
  ContactPerson = 7,
  LandRegisterQuery = 9,
  SignatureCertification = 8,
  Generic = 12,
}
